import { HttpParams } from '@angular/common/http';

export function nonNullableParams(queryParams: Record<string, unknown>): HttpParams {
  return Object.entries(queryParams)
    .filter(([, value]) => {
      const isEmpty = value === '';
      const isNull = value === null;
      const isUndefined = value === undefined;

      return !isEmpty && !isNull && !isUndefined;
    })
    .reduce((params, [key, value]) => {
      return params.set(key, String(value));
    }, new HttpParams());
}
